import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IPageContent as IBapContent } from 'interfaces/buildAndPrice';
import { IPageContent as IPowertrainContent } from 'interfaces/powertrain';
import { IPageContent as IPackageContent } from 'interfaces/package';
import { IPageContent as IReserveContent } from 'interfaces/reserve';
import { IEstPayPageContent } from 'interfaces/estimatePayments';

interface IBapSettings {
  exteriorAngles: string[];
  interiorAngles: string[];
  tekionSummaryScript: string;
}

interface IPageContentProps {
  bap: IBapContent;
  bapSettings: IBapSettings;
  featureToggles: { [key: string]: boolean };
  powertrain: IPowertrainContent;
  packages: IPackageContent;
  reserve: IReserveContent;
  estPay: IEstPayPageContent;
}
const footerEmpty = {
  copyright: '',
  disclaimer: '',
  resources: {
    heading: '',
    links: [],
  },
  navigation: {
    links: [],
  },
  languages: {
    heading: '',
    links: [],
  },
};

const pageContentEmpty = {
  labels: {},
  ctas: {},
};

const pageContentModalEmpty = {
  ...pageContentEmpty,
  modals: {},
};

const bapContentEmpty = {
  ...pageContentModalEmpty,
  footer: footerEmpty,
  featureToggles: {},
};

const bapSettingsEmpty = {
  exteriorAngles: [],
  interiorAngles: [],
  tekionSummaryScript: '',
};

const estPayEmpty = {
  ...pageContentEmpty,
  disclaimers: {},
  featureToggles: {},
};

const initialState: IPageContentProps = {
  bap: bapContentEmpty,
  bapSettings: bapSettingsEmpty,
  featureToggles: {},
  powertrain: pageContentModalEmpty,
  packages: pageContentModalEmpty,
  reserve: pageContentEmpty,
  estPay: estPayEmpty,
};

export const pageContent = createSlice({
  name: 'pageContent',
  initialState,
  reducers: {
    setPowertrainContent: (
      state,
      action: PayloadAction<IPowertrainContent>
    ) => {
      state.powertrain = action.payload;
    },
    resetPowertrainLabels: (state) => {
      state.powertrain = initialState.powertrain;
    },
    setPackagesContent: (state, action: PayloadAction<IPackageContent>) => {
      state.packages = action.payload;
    },
    resetPackagesLabels: (state) => {
      state.packages = initialState.packages;
    },
    setBapContent: (
      state,
      action: PayloadAction<{
        content: IBapContent;
        settings: IBapSettings;
        featureToggles: { [key: string]: boolean };
      }>
    ) => {
      state.bap = action.payload.content;
      state.bapSettings = action.payload.settings;
      state.featureToggles = action.payload.featureToggles;
    },
    setEstPayContent: (state, action: PayloadAction<IEstPayPageContent>) => {
      state.estPay = action.payload;
    },
    resetBapLabels: (state) => {
      state.bap = initialState.bap;
    },
    setReserveContent: (state, action: PayloadAction<IReserveContent>) => {
      state.reserve = action.payload;
    },
    resetReserveLabels: (state) => {
      state.reserve = initialState.reserve;
    },
  },
});

export const {
  setPowertrainContent,
  resetPowertrainLabels,
  setPackagesContent,
  resetPackagesLabels,
  setBapContent,
  resetBapLabels,
  setReserveContent,
  resetReserveLabels,
  setEstPayContent,
} = pageContent.actions;
export default pageContent.reducer;
